export const BLOG = 'https://blog.millions.co/';
export const CAREERS = 'https://careers.millions.co/';
export const ABOUT_US = 'https://follow.millions.co/about-us';
export const ADVERTISE = 'https://advertising.millions.co/';
export const HOST_A_PPV = 'https://follow.millions.co/ppv-services';
export const CREATOR = 'https://info.millions.co/creators/';
export const FANS = 'https://follow.millions.co/what-does-millions-do';
export const INFO = 'https://info.millions.co/';
export const EVENTS = 'https://info.millions.co/events/';
export const CREATORS = 'https://info.millions.co/creators/';
export const CONTACT = 'https://info.millions.co/contact/';
export const ABOUT = 'https://info.millions.co/about-us/';

export const APPLE_APP_STORE_URL = 'https://apps.apple.com/app/id6478323505';
export const APPLE_APP_ID = '6478323505';

export const GOOGLE_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.millions.store.prod&hl=en';
export const ANDROID_PACKAGE = 'com.millions.store.prod';

export const APP_DEEP_LINK_SCHEME = 'millions';
